import { LinkClassKey, LinkProps } from "@material-ui/core";
import { MuiComponentThemeDefinition } from "../utils";

export const MuiLink: MuiComponentThemeDefinition<LinkClassKey, LinkProps> = {
  props: {
    underline: "none",
  },
  override: () => ({}),
};
